import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import useProductName, { DEFAULT_PRODUCT_NAME } from "brand-customization/useProductName";
import { Icon } from "components/common";
const StyledIcon = styled(Icon)`
  color: #000;
`;
const RightLogo = ({ isDefault }) => {
  if (isDefault)
    return /* @__PURE__ */ React.createElement("g", { id: "Group_64" }, /* @__PURE__ */ React.createElement("g", { id: "Graphic_61" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M 1312.7145 502 C 1360.7883 502 1395.4426 539.0138 1395.4426 582.0737 C 1395.4426 625.871 1362.5578 662 1312.7145 662 C 1262.8712 662 1229.9864 625.871 1229.9864 582.0737 C 1229.839 539.0138 1264.4933 502 1312.7145 502 Z M 1258.0048 582.0737 C 1258.0048 611.41935 1283.2214 637.2258 1312.567 637.2258 C 1341.9127 637.2258 1367.1293 611.41935 1367.1293 582.0737 C 1367.1293 550.36866 1341.9127 526.6267 1312.567 526.6267 C 1283.3689 526.6267 1258.0048 550.36866 1258.0048 582.0737 Z",
        fill: "#ff3633"
      }
    )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_60" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M 1277.7652 577.6498 C 1279.9772 577.6498 1281.8942 578.8295 1282.9265 580.74654 L 1287.7929 580.74654 L 1295.461 562.31336 C 1295.756 561.4286 1296.6408 560.69124 1297.5256 560.3963 C 1299.1477 560.1014 1300.7698 560.9862 1301.0648 562.6083 L 1309.1753 598.2949 L 1317.4334 550.2212 C 1317.5809 549.0415 1318.4657 548.1567 1319.6454 547.86175 C 1321.2675 547.41935 1322.8896 548.4516 1323.332 550.0737 L 1332.18 586.20276 L 1336.7514 572.7834 C 1336.8989 572.19355 1337.3412 571.6037 1337.9311 571.1613 C 1339.2583 570.2765 1341.1753 570.5714 1342.0601 571.8986 L 1345.8942 577.35484 C 1346.0417 578.682 1346.0417 580.0092 1346.0417 581.3364 C 1346.0417 583.106 1345.8942 584.8756 1345.7468 586.4977 C 1345.1569 586.3502 1344.7145 585.9078 1344.2721 585.46544 L 1340.438 580.1567 L 1334.5394 598 C 1333.9495 599.6221 1332.3274 600.35945 1330.7053 599.91705 C 1329.673 599.6221 1328.9357 598.7373 1328.7883 597.8525 L 1320.8251 565.7051 L 1312.4196 614.5161 C 1312.1247 616.13825 1310.65 617.1705 1309.0279 617.02304 C 1307.7007 616.8756 1306.8159 615.8433 1306.521 614.5161 L 1297.5256 573.2258 L 1292.6592 584.8756 C 1292.2168 586.0553 1291.0371 586.7926 1289.8574 586.7926 L 1282.9265 586.7926 C 1281.8942 588.5622 1279.9772 589.74194 1277.7652 589.74194 C 1274.521 589.74194 1271.7191 587.08756 1271.7191 583.69585 C 1271.8666 580.4516 1274.521 577.6498 1277.7652 577.6498 Z",
        fill: "#a6afbd"
      }
    )));
  return /* @__PURE__ */ React.createElement("foreignObject", { x: "1230", y: "502", width: "165", height: "160" }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "database", size: "huge" }));
};
const LeftLogo = ({ isDefault }) => {
  if (isDefault)
    return /* @__PURE__ */ React.createElement("g", { id: "Group_65" }, /* @__PURE__ */ React.createElement("g", { id: "Graphic_63" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M 312.00023 502 C 360.07397 502 394.72835 539.0138 394.72835 582.0737 C 394.72835 625.871 361.84355 662 312.00023 662 C 262.15692 662 229.27212 625.871 229.27212 582.0737 C 229.12466 539.0138 263.77904 502 312.00023 502 Z M 257.29056 582.0737 C 257.29056 611.41935 282.50715 637.2258 311.85277 637.2258 C 341.1984 637.2258 366.415 611.41935 366.415 582.0737 C 366.415 550.36866 341.1984 526.6267 311.85277 526.6267 C 282.6546 526.6267 257.29056 550.36866 257.29056 582.0737 Z",
        fill: "#ff3633"
      }
    )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_62" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M 277.05093 577.6498 C 279.2629 577.6498 281.17996 578.8295 282.2122 580.74654 L 287.07858 580.74654 L 294.74678 562.31336 C 295.0417 561.4286 295.9265 560.69124 296.8113 560.3963 C 298.4334 560.1014 300.05553 560.9862 300.35046 562.6083 L 308.46106 598.2949 L 316.71913 550.2212 C 316.8666 549.0415 317.7514 548.1567 318.9311 547.86175 C 320.55323 547.41935 322.17535 548.4516 322.61775 550.0737 L 331.46567 586.20276 L 336.0371 572.7834 C 336.18457 572.19355 336.62696 571.6037 337.21682 571.1613 C 338.544 570.2765 340.46106 570.5714 341.34586 571.8986 L 345.17996 577.35484 C 345.32742 578.682 345.32742 580.0092 345.32742 581.3364 C 345.32742 583.106 345.17996 584.8756 345.0325 586.4977 C 344.44263 586.3502 344.00023 585.9078 343.55784 585.46544 L 339.72374 580.1567 L 333.8251 598 C 333.23526 599.6221 331.61314 600.35945 329.991 599.91705 C 328.95876 599.6221 328.22143 598.7373 328.07397 597.8525 L 320.11083 565.7051 L 311.7053 614.5161 C 311.41037 616.13825 309.9357 617.1705 308.3136 617.02304 C 306.9864 616.8756 306.1016 615.8433 305.8067 614.5161 L 296.8113 573.2258 L 291.94493 584.8756 C 291.50254 586.0553 290.3228 586.7926 289.1431 586.7926 L 282.2122 586.7926 C 281.17996 588.5622 279.2629 589.74194 277.05093 589.74194 C 273.8067 589.74194 271.00484 587.08756 271.00484 583.69585 C 271.1523 580.4516 273.8067 577.6498 277.05093 577.6498 Z",
        fill: "#a6afbd"
      }
    )));
  return /* @__PURE__ */ React.createElement("foreignObject", { x: "230", y: "502", width: "165", height: "160" }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "database", size: "huge" }));
};
const StyledSpan = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: ${theme.fonts.family.body};
    color: #000;
    width: 100%;
    height: 100%;
  `
);
const TextSpan = ({
  children = null,
  transform,
  width = 380
}) => /* @__PURE__ */ React.createElement("foreignObject", { width, height: "150", fontSize: "58", transform }, /* @__PURE__ */ React.createElement(StyledSpan, null, children));
const ForwarderDiagram = () => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const isDefaultProductName = DEFAULT_PRODUCT_NAME === productName;
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-703 127 2212.7143 1142", width: "100%", height: "100%" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "marker",
    {
      orient: "auto",
      overflow: "visible",
      markerUnits: "strokeWidth",
      id: "FilledArrow_Marker",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      viewBox: "-1 -2 5 4",
      markerWidth: 5,
      markerHeight: 4,
      color: "black"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M 2.24 0 L 0 -.84 L 0 .84 Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 1 })
  ), /* @__PURE__ */ React.createElement(
    "marker",
    {
      orient: "auto",
      overflow: "visible",
      markerUnits: "strokeWidth",
      id: "FilledArrow_Marker_2",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      viewBox: "-1 -3 5 6",
      markerWidth: 5,
      markerHeight: 6,
      color: "black"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M 2.8 0 L 0 -1.05 L 0 1.05 Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 1 })
  ), /* @__PURE__ */ React.createElement(
    "marker",
    {
      orient: "auto",
      overflow: "visible",
      markerUnits: "strokeWidth",
      id: "FilledArrow_Marker_3",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      viewBox: "-1 -2 5 4",
      markerWidth: 5,
      markerHeight: 4,
      color: "black"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M 2.5333333 0 L 0 -.95 L 0 .95 Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 1 })
  )), /* @__PURE__ */ React.createElement("g", { id: "Canvas_1", strokeDasharray: "none", stroke: "none", fill: "none", fillOpacity: "1", strokeOpacity: "1" }, /* @__PURE__ */ React.createElement("title", null, t("forwarder_diagram.canvas")), /* @__PURE__ */ React.createElement("g", { id: "Canvas_1: Layer 1" }, /* @__PURE__ */ React.createElement("title", null, t("forwarder_diagram.diagram")), /* @__PURE__ */ React.createElement("g", { id: "Graphic_35" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -697 128 L 569.1194 128 C 571.8808 128 574.1194 130.23858 574.1194 133 L 574.1194 1263 C 574.1194 1265.7614 571.8808 1268 569.1194 1268 L -697 1268 C -699.7614 1268 -702 1265.7614 -702 1263 L -702 133 C -702 130.23858 -699.7614 128 -697 128 Z",
      fill: "#f3f1f4"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -697 128 L 569.1194 128 C 571.8808 128 574.1194 130.23858 574.1194 133 L 574.1194 1263 C 574.1194 1265.7614 571.8808 1268 569.1194 1268 L -697 1268 C -699.7614 1268 -702 1265.7614 -702 1263 L -702 133 C -702 130.23858 -699.7614 128 -697 128 Z",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_2" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -450 265 L -590 265 C -595.5228 265 -600 260.5228 -600 255 L -600 235 C -600 229.4772 -595.5228 225 -590 225 L -450 225 C -444.4772 225 -440 229.4772 -440 235 L -440 255 C -440 260.5228 -444.4772 265 -450 265 Z M -465 237.5 C -469.1422 237.5 -472.5 240.8578 -472.5 245 C -472.5 249.1422 -469.1422 252.5 -465 252.5 C -460.8578 252.5 -457.5 249.1422 -457.5 245 C -457.5 240.8578 -460.8578 237.5 -465 237.5 Z M -485 237.5 C -489.1422 237.5 -492.5 240.8578 -492.5 245 C -492.5 249.1422 -489.1422 252.5 -485 252.5 C -480.8578 252.5 -477.5 249.1422 -477.5 245 C -477.5 240.8578 -480.8578 237.5 -485 237.5 Z M -450 315 L -590 315 C -595.5228 315 -600 310.5228 -600 305 L -600 285 C -600 279.4772 -595.5228 275 -590 275 L -450 275 C -444.4772 275 -440 279.4772 -440 285 L -440 305 C -440 310.5228 -444.4772 315 -450 315 Z M -465 287.5 C -469.1422 287.5 -472.5 290.8578 -472.5 295 C -472.5 299.1422 -469.1422 302.5 -465 302.5 C -460.8578 302.5 -457.5 299.1422 -457.5 295 C -457.5 290.8578 -460.8578 287.5 -465 287.5 Z M -485 287.5 C -489.1422 287.5 -492.5 290.8578 -492.5 295 C -492.5 299.1422 -489.1422 302.5 -485 302.5 C -480.8578 302.5 -477.5 299.1422 -477.5 295 C -477.5 290.8578 -480.8578 287.5 -485 287.5 Z M -450 365 L -590 365 C -595.5228 365 -600 360.5228 -600 355 L -600 335 C -600 329.4772 -595.5228 325 -590 325 L -450 325 C -444.4772 325 -440 329.4772 -440 335 L -440 355 C -440 360.5228 -444.4772 365 -450 365 Z M -465 337.5 C -469.1422 337.5 -472.5 340.8578 -472.5 345 C -472.5 349.1422 -469.1422 352.5 -465 352.5 C -460.8578 352.5 -457.5 349.1422 -457.5 345 C -457.5 340.8578 -460.8578 337.5 -465 337.5 Z M -485 337.5 C -489.1422 337.5 -492.5 340.8578 -492.5 345 C -492.5 349.1422 -489.1422 352.5 -485 352.5 C -480.8578 352.5 -477.5 349.1422 -477.5 345 C -477.5 340.8578 -480.8578 337.5 -485 337.5 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_6" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -103 237.8572 L -103 252.1428 C -103 264.7322 -134.35406 275 -173 275 C -211.64594 275 -243 264.7322 -243 252.1428 L -243 237.8572 C -243 225.2678 -211.64594 215 -173 215 C -134.35406 215 -103 225.2678 -103 237.8572 Z M -103 270 L -103 302.1428 C -103 314.7322 -134.35406 325 -173 325 C -211.64594 325 -243 314.7322 -243 302.1428 L -243 270 C -227.96094 280.3572 -200.435 285.17875 -173 285.17875 C -145.565 285.17875 -118.03938 280.3572 -103 270 Z M -103 320 L -103 352.1428 C -103 364.7322 -134.35406 375 -173 375 C -211.64594 375 -243 364.7322 -243 352.1428 L -243 320 C -227.96094 330.3572 -200.435 335.17875 -173 335.17875 C -145.565 335.17875 -118.03938 330.3572 -103 320 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_14" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M 892 626.875 C 893.8304 622.0982 894.8571 616.875 894.8571 611.4286 C 894.8571 587.76786 875.6607 568.5714 852 568.5714 C 843.2054 568.5714 834.9911 571.25 828.2054 575.8036 C 815.8393 554.375 792.7589 540 766.2857 540 C 726.8214 540 694.85714 571.9643 694.85714 611.4286 C 694.85714 612.6339 694.9018 613.8393 694.9464 615.04464 C 669.9464 623.8393 652 647.6786 652 675.7143 C 652 711.20536 680.79464 740 716.2857 740 L 880.5714 740 C 912.1339 740 937.7143 714.41964 937.7143 682.85714 C 937.7143 655.2232 918.0714 632.14286 892 626.875 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_16" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M 255 455 L 369 455 C 407 455 426 455 448.8 462.6 C 467.8 470.2 486.8 489.2 494.4 508.2 C 502 531 502 550 502 588 L 502 702 C 502 740 502 759 494.4 781.8 C 486.8 800.8 467.8 819.8 448.8 827.4 C 426 835 407 835 369 835 L 255 835 C 217 835 198 835 175.2 827.4 C 156.2 819.8 137.2 800.8 129.6 781.8 C 122 759 122 740 122 702 L 122 588 C 122 550 122 531 129.6 508.2 C 137.2 489.2 156.2 470.2 175.2 462.6 C 198 455 217 455 255 455 M 255 455",
      fill: "white"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M 255 455 L 369 455 C 407 455 426 455 448.8 462.6 C 467.8 470.2 486.8 489.2 494.4 508.2 C 502 531 502 550 502 588 L 502 702 C 502 740 502 759 494.4 781.8 C 486.8 800.8 467.8 819.8 448.8 827.4 C 426 835 407 835 369 835 L 255 835 C 217 835 198 835 175.2 827.4 C 156.2 819.8 137.2 800.8 129.6 781.8 C 122 759 122 740 122 702 L 122 588 C 122 550 122 531 129.6 508.2 C 137.2 489.2 156.2 470.2 175.2 462.6 C 198 455 217 455 255 455 M 255 455",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_15" }, /* @__PURE__ */ React.createElement(TextSpan, { transform: "translate(121 670)" }, t("forwarder_diagram.forwarder"))), /* @__PURE__ */ React.createElement("g", { id: "Graphic_24" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M 1255.7143 455 L 1369.7143 455 C 1407.7143 455 1426.7143 455 1449.5143 462.6 C 1468.5143 470.2 1487.5143 489.2 1495.1143 508.2 C 1502.7143 531 1502.7143 550 1502.7143 588 L 1502.7143 702 C 1502.7143 740 1502.7143 759 1495.1143 781.8 C 1487.5143 800.8 1468.5143 819.8 1449.5143 827.4 C 1426.7143 835 1407.7143 835 1369.7143 835 L 1255.7143 835 C 1217.7143 835 1198.7143 835 1175.9143 827.4 C 1156.9143 819.8 1137.9143 800.8 1130.3143 781.8 C 1122.7143 759 1122.7143 740 1122.7143 702 L 1122.7143 588 C 1122.7143 550 1122.7143 531 1130.3143 508.2 C 1137.9143 489.2 1156.9143 470.2 1175.9143 462.6 C 1198.7143 455 1217.7143 455 1255.7143 455 M 1255.7143 455",
      fill: "white"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M 1255.7143 455 L 1369.7143 455 C 1407.7143 455 1426.7143 455 1449.5143 462.6 C 1468.5143 470.2 1487.5143 489.2 1495.1143 508.2 C 1502.7143 531 1502.7143 550 1502.7143 588 L 1502.7143 702 C 1502.7143 740 1502.7143 759 1495.1143 781.8 C 1487.5143 800.8 1468.5143 819.8 1449.5143 827.4 C 1426.7143 835 1407.7143 835 1369.7143 835 L 1255.7143 835 C 1217.7143 835 1198.7143 835 1175.9143 827.4 C 1156.9143 819.8 1137.9143 800.8 1130.3143 781.8 C 1122.7143 759 1122.7143 740 1122.7143 702 L 1122.7143 588 C 1122.7143 550 1122.7143 531 1130.3143 508.2 C 1137.9143 489.2 1156.9143 470.2 1175.9143 462.6 C 1198.7143 455 1217.7143 455 1255.7143 455 M 1255.7143 455",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_21" }, /* @__PURE__ */ React.createElement(TextSpan, { transform: "translate(1123 670)" }, productName)), /* @__PURE__ */ React.createElement("g", { id: "Graphic_36" }, /* @__PURE__ */ React.createElement(TextSpan, { width: 480, transform: "translate(-680 1150)" }, t("forwarder_diagram.your_infrastructure"))), /* @__PURE__ */ React.createElement("g", { id: "Line_42" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -440 295 L -60.858624 295 L -60.858624 645 L 78.1 645",
      markerEnd: "url(#FilledArrow_Marker)",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "10"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Line_45" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -430 1005 L -61.155134 1005 L -61.155134 645 L 72.5 645",
      markerEnd: "url(#FilledArrow_Marker_2)",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "10"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Line_46" }, /* @__PURE__ */ React.createElement(
    "line",
    {
      x1: "-450",
      y1: "645",
      x2: "78.1",
      y2: "645",
      markerEnd: "url(#FilledArrow_Marker)",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "10"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_47" }, /* @__PURE__ */ React.createElement("rect", { x: "-241", y: "938", width: "138", height: "94", fill: "white" }), /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "-241",
      y: "938",
      width: "138",
      height: "94",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_48" }, /* @__PURE__ */ React.createElement("rect", { x: "-590", y: "938", width: "145", height: "103", fill: "white" }), /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "-590",
      y: "938",
      width: "145",
      height: "103",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_49" }, /* @__PURE__ */ React.createElement("rect", { x: "-583", y: "574", width: "127", height: "114", fill: "white" }), /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "-583",
      y: "574",
      width: "127",
      height: "114",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_3" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -465 565 L -575 565 C -583.28125 565 -590 571.71875 -590 580 L -590 710 C -590 718.28125 -583.28125 725 -575 725 L -465 725 C -456.71875 725 -450 718.28125 -450 710 L -450 580 C -450 571.71875 -456.71875 565 -465 565 Z M -520 715 C -525.53125 715 -530 710.53125 -530 705 C -530 699.46875 -525.53125 695 -520 695 C -514.46875 695 -510 699.46875 -510 705 C -510 710.53125 -514.46875 715 -520 715 Z M -465 681.25 C -465 683.3125 -466.6875 685 -468.75 685 L -571.25 685 C -573.3125 685 -575 683.3125 -575 681.25 L -575 583.75 C -575 581.6875 -573.3125 580 -571.25 580 L -468.75 580 C -466.6875 580 -465 581.6875 -465 583.75 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_5" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -445 925 L -595 925 C -603.28125 925 -610 931.7188 -610 940 L -610 1040 C -610 1048.2812 -603.28125 1055 -595 1055 L -535 1055 L -540 1070 L -562.5 1070 C -566.65625 1070 -570 1073.3438 -570 1077.5 C -570 1081.6562 -566.65625 1085 -562.5 1085 L -477.5 1085 C -473.34375 1085 -470 1081.6562 -470 1077.5 C -470 1073.3438 -473.34375 1070 -477.5 1070 L -500 1070 L -505 1055 L -445 1055 C -436.71875 1055 -430 1048.2812 -430 1040 L -430 940 C -430 931.7188 -436.71875 925 -445 925 Z M -450 1035 L -590 1035 L -590 945 L -450 945 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Graphic_4" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M -78 1055 L -153.76875 1055 C -154 1061.1906 -158.36562 1065 -164 1065 L -183 1065 C -188.84062 1065 -193.31875 1059.5406 -193.24062 1055 L -268 1055 C -270.75 1055 -273 1057.25 -273 1060 L -273 1065 C -273 1076 -264 1085 -253 1085 L -93 1085 C -82 1085 -73 1076 -73 1065 L -73 1060 C -73 1057.25 -75.25 1055 -78 1055 Z M -93 940 C -93 931.75 -99.75 925 -108 925 L -238 925 C -246.25 925 -253 931.75 -253 940 L -253 1045 L -93 1045 Z M -113 1025 L -233 1025 L -233 945 L -113 945 Z",
      fill: "black"
    }
  )), /* @__PURE__ */ React.createElement("g", { id: "Line_51" }, /* @__PURE__ */ React.createElement(
    "line",
    {
      x1: "509",
      y1: "645",
      x2: "1056.2143",
      y2: "645",
      markerEnd: "url(#FilledArrow_Marker_3)",
      stroke: "black",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "15"
    }
  )), /* @__PURE__ */ React.createElement(RightLogo, { isDefault: isDefaultProductName }), /* @__PURE__ */ React.createElement(LeftLogo, { isDefault: isDefaultProductName }))));
};
export default ForwarderDiagram;
